import Api from '../Api'

export interface IFinanceUrlRedirector {
  id: number
  from: string
  to: string
  active: boolean
  user: {
    id: number
    name: string
  }
  created_at: string
}

export interface ICreateUpdateFinanceUrlRedirectorPayload {
  from: string
  to: string
}

export interface IListResponse {
  data: IFinanceUrlRedirector[]
  recordsTotal: number
  recordsFiltered: number
}

export interface IGetFinanceUrlRedirectorResponse {
  id: number
  from: string
  to: string
  active: boolean
  created_by: {
    id: number
    name: string
  }
  created_at: string
}

export class FinanceUrlRedirectorService {
  async list(search?: string, page?: number, pageSize?: number): Promise<IListResponse> {
    const params = {
      search: search || '',
      page: page || 1, // Default to page 1 if not provided
      page_size: pageSize || 25 // Default to 25 items per page if not provided,
    }
    const { data } = await Api.get('/finance-url-redirectors', { params })
    return data
  }

  async get(id: number): Promise<IGetFinanceUrlRedirectorResponse> {
    const { data } = await Api.get(`/finance-url-redirectors/${id}`)
    return data
  }

  async delete(id: number): Promise<void> {
    await Api.delete(`/finance-url-redirectors/${id}`)
  }

  async create(payload: ICreateUpdateFinanceUrlRedirectorPayload): Promise<IFinanceUrlRedirector> {
    const { data } = await Api.post('/finance-url-redirectors', payload)
    return data
  }

  async update(id: number, payload: ICreateUpdateFinanceUrlRedirectorPayload): Promise<IFinanceUrlRedirector> {
    const { data } = await Api.put(`/finance-url-redirectors/${id}`, payload)
    return data
  }

  async updateActive(id: number, active: boolean): Promise<IFinanceUrlRedirector> {
    const { data } = await Api.put(`/finance-url-redirectors/${id}`, { active })
    return data
  }
}
